import React, { Component } from "react";
import MetaTags from 'react-meta-tags';
import { translate } from "react-i18next";
import Footer from "../layout/footer";
import './about.css';

class About extends Component {
    goToTop() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "initial"
        });
    }
    componentDidMount() {

    }
    render() {
        const { t } = this.props;
        let path = window.location.pathname;
        let match = path.slice(0, 3);

        return (
            <div className={match === "/tc" ? "tc d-flex justify-content-center" : match === "/sc" ? "sc d-flex justify-content-center" : "d-flex justify-content-center"}>
                <MetaTags>
                    <title>{t('about-meta-title')}</title>
                    <meta name="title" content={t('about-meta-title')} />
                    <meta name="description" content={t('about-meta-description')} />
                    <meta name="keywords" content={t('about-meta-keywords')} />
                </MetaTags>
                <div id="div-about">
                    <div className="about-banner">
                        <div className="d-flex justify-content-center">
                            <div className="">
                                <div className="div-about-banner-logo mx-5">
                                    <img src={t('carousel-logo')} className="d-none d-sm-block about-banner-logo" alt="" />
                                    <img src={t('about-logo')} className="d-block d-sm-none about-banner-logo" alt="" />
                                </div>
                                <p className="mt-4 mx-5 w-sm-75">{t('about-banner-text')}</p>
                                <p className="mx-5 w-sm-75">{t('about-banner-text-2')}</p>
                            </div>
                        </div>
                        <div className="d-flex justify-content-center text-center mt-3 mx-5 ">
                            <div className="about-banner-border py-3 mb-5">
                                <h3>{t('about-banner-text-3')}</h3>
                            </div>

                        </div>
                    </div>
                    <div className="about-vision">
                        <div className="d-flex justify-content-center text-center pt-5 mx-5">
                            <h1>{t('about-vision-headline')}</h1>
                        </div>
                        <div className="d-flex justify-content-center text-center py-5 mx-5">
                            <div className="about-vision-content col-12"></div>
                        </div>
                    </div>
                    <div id="about-timeline-carousel" className="carousel slide show-neighbors pt-4" data-bs-touch="true">
                        <div className="text-center d-flex justify-content-center">
                            <h1>{t('about-timeline-headline')}</h1>
                        </div>
                        <div className="text-center d-flex justify-content-center px-3 my-3">
                            <p className="w-auto w-sm-75 w-md-50">{t('about-timeline-content')}</p>
                        </div>
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#about-timeline-carousel" data-bs-slide-to="0" className="active btn-carousel-indicators btn-highlight02"
                                aria-current="true" aria-label="Slide 1">{t('about-timeline-date-1')}</button>
                            <button type="button" data-bs-target="#about-timeline-carousel" data-bs-slide-to="1" className="btn-carousel-indicators btn-highlight02"
                                aria-label="Slide 2">{t('about-timeline-date-2')}</button>
                            <button type="button" data-bs-target="#about-timeline-carousel" data-bs-slide-to="2" className="btn-carousel-indicators btn-highlight02"
                                aria-label="Slide 3">{t('about-timeline-date-3')}</button>
                            <button type="button" data-bs-target="#about-timeline-carousel" data-bs-slide-to="3" className="btn-carousel-indicators btn-highlight02 d-none"
                                aria-label="Slide 4">{t('about-timeline-date-3')}</button>
                            <button type="button" data-bs-target="#about-timeline-carousel" data-bs-slide-to="4" className="btn-carousel-indicators btn-highlight02 d-none"
                                aria-label="Slide 5">{t('about-timeline-date-3')}</button>
                        </div>

                        <div className="carousel-inner">
                            <div className="carousel-item my-4 active">
                                <div className="item__third mx-3 item_opacity">
                                    <div className="about-timeline-carousel-item-5 text-center d-flex justify-content-center align-items-center px-5"><div>{t('about-timeline-detail-5')}</div></div>
                                </div>
                                <div className="item__third mx-3 item_normal">
                                    <div className="about-timeline-carousel-item-1 text-center d-flex justify-content-center align-items-center px-5"><div>{t('about-timeline-detail-1')}</div></div>
                                </div>
                                <div className="item__third mx-3 item_opacity">
                                    <div className="about-timeline-carousel-item-2 text-center d-flex justify-content-center align-items-center px-5"><div>{t('about-timeline-detail-2')}</div></div>
                                </div>
                            </div>
                            <div className="carousel-item my-4">
                                <div className="item__third mx-3 item_opacity">
                                    <div className="about-timeline-carousel-item-1 text-center d-flex justify-content-center align-items-center px-5"><strong>{t('about-timeline-detail-1')}</strong></div>
                                </div>
                                <div className="item__third mx-3 item_normal">
                                    <div className="about-timeline-carousel-item-2 text-center d-flex justify-content-center align-items-center px-5"><strong>{t('about-timeline-detail-2')}</strong></div>
                                </div>
                                <div className="item__third mx-3 item_opacity">
                                    <div className="about-timeline-carousel-item-3 text-center d-flex justify-content-center align-items-center px-5"><strong>{t('about-timeline-detail-3')}</strong></div>
                                </div>
                            </div>
                            <div className="carousel-item my-4">
                                <div className="item__third mx-3 item_opacity">
                                    <div className="about-timeline-carousel-item-2 text-center d-flex justify-content-center align-items-center px-5"><strong>{t('about-timeline-detail-2')}</strong></div>
                                </div>
                                <div className="item__third mx-3 item_normal">
                                    <div className="about-timeline-carousel-item-3 text-center d-flex justify-content-center align-items-center px-5"><strong>{t('about-timeline-detail-3')}</strong></div>
                                </div>
                                <div className="item__third mx-3 item_normal">
                                    <div className="about-timeline-carousel-item-4 text-center d-flex justify-content-center align-items-center px-5"><strong>{t('about-timeline-detail-4')}</strong></div>
                                </div>
                            </div>
                            <div className="carousel-item my-4">
                                <div className="item__third mx-3 item_normal">
                                    <div className="about-timeline-carousel-item-3 text-center d-flex justify-content-center align-items-center px-5"><strong>{t('about-timeline-detail-3')}</strong></div>
                                </div>
                                <div className="item__third mx-3 item_normal">
                                    <div className="about-timeline-carousel-item-4 text-center d-flex justify-content-center align-items-center px-5"><strong>{t('about-timeline-detail-4')}</strong></div>
                                </div>
                                <div className="item__third mx-3 item_normal">
                                    <div className="about-timeline-carousel-item-5 text-center d-flex justify-content-center align-items-center px-5"><strong>{t('about-timeline-detail-5')}</strong></div>
                                </div>
                            </div>
                            <div className="carousel-item my-4">
                                <div className="item__third mx-3 item_normal">
                                    <div className="about-timeline-carousel-item-4 text-center d-flex justify-content-center align-items-center px-5"><strong>{t('about-timeline-detail-4')}</strong></div>
                                </div>
                                <div className="item__third mx-3 item_normal">
                                    <div className="about-timeline-carousel-item-5 text-center d-flex justify-content-center align-items-center px-5"><strong>{t('about-timeline-detail-5')}</strong></div>
                                </div>
                                <div className="item__third mx-3 item_opacity">
                                    <div className="about-timeline-carousel-item-1 text-center d-flex justify-content-center align-items-center px-5"><strong>{t('about-timeline-detail-1')}</strong></div>
                                </div>
                            </div>
                            <button className="carousel-control-prev" type="button" data-bs-target="#about-timeline-carousel" data-bs-slide="prev">
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Previous</span>
                            </button>
                            <button className="carousel-control-next" type="button" data-bs-target="#about-timeline-carousel" data-bs-slide="next">
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Next</span>
                            </button>
                        </div>

                    </div>
                    {/* <div className="about-timeline">
                        <div className="d-flex justify-content-center text-center pt-5 mx-5">
                            <h1>{t('about-timeline-headline')}</h1>
                        </div>
                        <div className="d-flex justify-content-center text-center mt-3 mx-5">
                            <p>{t('about-timeline-content')}</p>
                        </div>
                        <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <img src="..." className="d-block w-100" alt="...">
                                </div>
                                <div className="carousel-item">
                                    <img src="..." className="d-block w-100" alt="...">
                                </div>
                                <div className="carousel-item">
                                    <img src="..." className="d-block w-100" alt="...">
                                </div>
                            </div>
                            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Previous</span>
                            </button>
                            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div> */}

                    <Footer />
                    {/*  Modal */}
                    <div className="modal fade" id="myModal2" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content bg-black">
                                <div className="modal-body">
                                    <div className="d-flex justify-content-end">
                                        <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>


                                    <p>{t('alert-msg-1')}</p>
                                    {/* <iframe className="embed-responsive-item" src="" id="video" allowscriptaccess="always" title="Video"></iframe> */}

                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div >



        );
    }
}

// extended main view with translate hoc
export default translate("translations")(About);



// WEBPACK FOOTER //
// ./src/components/pages/about.js